// extracted by mini-css-extract-plugin
export default {"wrapper":"textArea_wrapper__+WMyB"};